module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "check-item"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-7"
  }, [_vm._v(_vm._s(_vm.i18n.videoPlayer))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('checker-status', {
    attrs: {
      "result": _vm.result.value
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.closed),
      expression: "!closed"
    }],
    staticClass: "row video-player"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.playerReady),
      expression: "!playerReady"
    }],
    staticClass: "init-holder"
  }, [_vm._v(_vm._s(_vm.i18n.videoPlayerInit))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.playerReady),
      expression: "playerReady"
    }]
  }, [_vm._m(0)]), _vm._v(" "), (_vm.result.error !== '') ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v(_vm._s(_vm.result.error))]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('video', {
    staticClass: "video-js vjs-default-skin vjs-big-play-centered",
    attrs: {
      "id": "testVideo",
      "controls": "",
      "preload": "auto",
      "width": "700",
      "height": "393",
      "poster": "http://virtualdestinations.6connex.com/upload/files/6connex/sync-test.png",
      "data-setup": "{}"
    }
  }, [_c('source', {
    attrs: {
      "src": "http://virtualdestinations.6connex.com/upload/files/6connex/sync-test.mp4",
      "type": "video/mp4"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": "http://virtualdestinations.6connex.com/upload/files/6connex/sync-test.webm",
      "type": "video/webm"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d4ca5ed6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoPlayer.vue
// module id = 296
// module chunks = 2